export default "__VITE_ASSET__CoKGvUou__"